import React, {FunctionComponent} from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Drawer } from '@material-ui/core';
import SideBarNav from './SideBarNav';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

interface Props {
  className?: String,
  onClose?: () => void,
  open: boolean,
  variant: 'permanent' | 'persistent' | 'temporary',
}

const SideBar: FunctionComponent<Props> = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={() => onClose && onClose()}
      open={open}
      variant={variant === null ? "permanent" : variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Divider className={classes.divider} />
        <SideBarNav
          isCollapsed={false}
          onSelect={onClose}
        />
      </div>
    </Drawer>
  );
};

export default SideBar;